import { render, staticRenderFns } from "./pogs-login.vue?vue&type=template&id=510141c7&"
import script from "./pogs-login.vue?vue&type=script&lang=js&"
export * from "./pogs-login.vue?vue&type=script&lang=js&"
import style0 from "./pogs-login.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports